import { render, staticRenderFns } from "./TbcDisburseInstallment.vue?vue&type=template&id=56933095&"
import script from "./TbcDisburseInstallment.vue?vue&type=script&lang=js&"
export * from "./TbcDisburseInstallment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports